/**
 * @file 获取pdf
 * @author Wanzhongyun
 */

import request from 'superagent';
import baseRequest from '../baseApiText';

export const getPDF = (version: string, lang: string, docName: string): Promise<request.Response> => {
    return baseRequest(
        request.get(`https://paddle-site-web.bj.bcebos.com/pdf/${docName}/${version}/paddlepaddle-${lang}.pdf`)
    );
};
